module.exports = __webpack_public_path__ + "static/media/Unicorn-Calligraphy.aef63819.ttf";